import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tripDetails: {},
  tripBookingAreas: {},
};

const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    saveTripDetails(state, action) {
      state.tripDetails = action.payload;
    },
    getTripBookingAreasSuccess(state, action) {
      state.tripBookingAreas = action.payload;
    },
    clearTripAreas(state) {
      state.tripBookingAreas = {};
    },
  },
});

export const { saveTripDetails, getTripBookingAreasSuccess, clearTripAreas } =
  homeSlice.actions;
export default homeSlice.reducer;
